/**
 * @generated SignedSource<<564bc4ac7ccdd4b7941c95f1c6f9f6ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type CourseControlNode$data = {
  readonly agenda?: {
    readonly id: string;
  };
  readonly course?: {
    readonly courseBucket: {
      readonly id: string;
      readonly slotDurations: ReadonlyArray<{
        readonly maxDurationMins: number;
        readonly startSlot: {
          readonly endSlotOptions: {
            readonly edges: ReadonlyArray<{
              readonly allowedPlayerCounts: ReadonlyArray<number | null | undefined> | null | undefined;
              readonly durationMins: number | null | undefined;
              readonly node: {
                readonly availability: SlotAvailability;
                readonly id: string;
                readonly time: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly time: string;
        };
      } | null | undefined>;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly facility: {
      readonly copyOverrides: {
        readonly course: {
          readonly singular: string;
        } | null | undefined;
      };
      readonly publicBookingPermissionSet: {
        readonly customerCanSelectCourt: boolean | null | undefined;
      } | null | undefined;
    };
    readonly id: string;
    readonly name: string;
  };
  readonly endSlotOptions?: {
    readonly edges: ReadonlyArray<{
      readonly allowedPlayerCounts: ReadonlyArray<number | null | undefined> | null | undefined;
      readonly durationMins: number | null | undefined;
      readonly node: {
        readonly availability: SlotAvailability;
        readonly id: string;
        readonly time: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id?: string;
  readonly time?: string;
  readonly " $fragmentSpreads": FragmentRefs<"useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot">;
  readonly " $fragmentType": "CourseControlNode";
};
export type CourseControlNode$key = {
  readonly " $data"?: CourseControlNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseControlNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "bookingId",
      "variableName": "bookingId"
    },
    {
      "kind": "Variable",
      "name": "bookingType",
      "variableName": "bookingType"
    },
    {
      "kind": "Variable",
      "name": "memberId",
      "variableName": "memberId"
    }
  ],
  "concreteType": "EndSlotOptionsConnection",
  "kind": "LinkedField",
  "name": "endSlotOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EndSlotOptionsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationMins",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowedPlayerCounts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availability",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "agendaId"
    },
    {
      "kind": "RootArgument",
      "name": "bookingId"
    },
    {
      "kind": "RootArgument",
      "name": "bookingType"
    },
    {
      "kind": "RootArgument",
      "name": "memberId"
    },
    {
      "kind": "RootArgument",
      "name": "startTime"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourseControlNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot"
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublicBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "publicBookingPermissionSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "customerCanSelectCourt",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "singular",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseBucket",
              "kind": "LinkedField",
              "name": "courseBucket",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "agendaId",
                      "variableName": "agendaId"
                    },
                    {
                      "kind": "Variable",
                      "name": "startsAt",
                      "variableName": "startTime"
                    }
                  ],
                  "concreteType": "SlotDurations",
                  "kind": "LinkedField",
                  "name": "slotDurations",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TimeSlot",
                      "kind": "LinkedField",
                      "name": "startSlot",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maxDurationMins",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "1819b040bb80e4d8025a0e752299755a";

export default node;
